import { render, staticRenderFns } from "./GeneralFields.vue?vue&type=template&id=5e5b7dc4&scoped=true"
import script from "./GeneralFields.vue?vue&type=script&lang=js"
export * from "./GeneralFields.vue?vue&type=script&lang=js"
import style0 from "./GeneralFields.vue?vue&type=style&index=0&id=5e5b7dc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5b7dc4",
  null
  
)

export default component.exports